<template>
  <div class="orders">
    <div class="orders__table" v-if="orders.length && !isLoading">
      <div class="orders__top">
        <div class="orders__column">
          <p class="orders__table-title">{{ t('profile.orders.order') }}</p>
        </div>
        <div class="orders__column">
          <p class="orders__table-title">{{ t('profile.orders.date') }}</p>
        </div>
        <div class="orders__column">
          <p class="orders__table-title">{{ t('profile.orders.status') }}</p>
        </div>
        <div class="orders__column">
          <p class="orders__table-title">{{ t('profile.orders.total') }}</p>
        </div>
        <div class="orders__column">
          <p class="orders__table-title">{{ t('profile.orders.details') }}</p>
        </div>
      </div>
      <order-card
          v-for="order in orders"
          :key="order.node.uuid"
          :order="order.node"
      />
    </div>
    <order-skeleton v-if="isLoading" />
    <div class="orders__empty" v-if="!orders.length && !isLoading">
      <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.5 22.6803C8.42401 22.6803 4.32001 18.5763 4.32001 13.5003C4.32001 8.42431 8.42401 4.32031 13.5 4.32031C18.576 4.32031 22.68 8.42431 22.68 13.5003C22.68 18.5763 18.576 22.6803 13.5 22.6803ZM13.5 5.40031C9.01801 5.40031 5.40001 9.01831 5.40001 13.5003C5.40001 17.9823 9.01801 21.6003 13.5 21.6003C17.982 21.6003 21.6 17.9823 21.6 13.5003C21.6 9.01831 17.982 5.40031 13.5 5.40031Z" fill="#2F2F49"/>
        <path d="M12.96 17.2796H14.04V18.3596H12.96V17.2796ZM13.824 16.1996H13.176L12.96 11.8796V8.63965H14.04V11.8796L13.824 16.1996Z" fill="#2F2F49"/>
      </svg>
      <p>{{ t('profile.orders.empty') }}</p>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {Orders} from "@/core/api/orders.js";
import {useAuthStore} from "@/stores/auth.js";
import {useI18n} from "vue-i18n";
import OrderCard from "@/components/cards/order-card.vue";
import OrderSkeleton from "@/components/skeletons/order-skeleton.vue";

const { t } = useI18n()
const authStore = useAuthStore()

const accessToken = computed(() => authStore.accessToken);
const userEmail = computed(() => authStore.user?.email);

const orders = ref([])
const isLoading = ref(true);

const fetchOrders = async () => {
  isLoading.value = true

  setTimeout(async () => {
    const res = await Orders.getOrders("", accessToken.value, userEmail.value);
    orders.value = res.data.orders.edges
      .filter((order) => order.node.status === 'FINISHED')
      // .filter((order) => order.node.status !== 'MOMENTAL')

    isLoading.value = false;
  }, 500);
}

onMounted(async () => {
  await fetchOrders()
})
</script>

<style lang="scss" scoped>
.orders {
  &__table {
    &-title {
      color: #2F2F2F;
      font-size: 16px;
      font-weight: 600;
      line-height: 30.8px;
      text-transform: uppercase;
    }
  }

  &__top {
    display: flex;
    align-items: center;
    border-bottom: 2px solid #E4E4E4;
    padding-bottom: 10px;
  }

  &__column {
    &:nth-child(1) {
      width: 15%;
    }
    &:nth-child(2) {
      width: 30%;
    }
    &:nth-child(3) {
      width: 18%;
    }
    &:nth-child(4) {
      width: 30%;
    }
    &:nth-child(5) {
      width: 10%;
      display: flex;
      justify-content: flex-end;
    }
  }

  &__empty {
    position: relative;
    width: 100%;
    border-radius: 10px;
    border: 1px solid #FF6162;
    display: grid;
    place-items: center;
    gap: 150px;
    padding: 17px 20px 17px 40px;

    & svg {
      position: absolute;
      top: 50%;
      left: 20px;
      transform: translateY(-50%);
    }
  }
}

@media (max-width: 850px) {
  .orders {
    overflow-x: auto;
    max-width: 70%;

    &__table {
      width: 750px;
    }
  }
}

@media (max-width: 550px) {
  .orders {
    max-width: 60%;
  }
}

@media (max-width: 450px) {
  .orders {
    max-width: 50%;
  }
}
</style>